import { getPerformance, trace } from "firebase/performance";
import { getApps } from "firebase/app";
import { createPersistedState } from "~/utils/persistedState";
import { useMetaTrackingIds } from "~/composables/useMetaTrackingIds";

interface dataPendeing {
  make: boolean;
  model: boolean;
  trim: boolean;
  carSerie: boolean;
  bodyType: boolean;
  version: boolean;
  fuelType: boolean;
  SeriesByYear: boolean;
  option: boolean;
  editbleAnnoncement: boolean
}

export interface SeriesfetchResult {
  id: number | undefined;
  name: string;
  items?: [
    {
      id: number;
      checked?: boolean;
      label?: string
    }
  ];
  title?: string;
  year?: string;
}
export interface Specification {
  id: number;
  name: string;
  value: any;
  unit: string;
}
type SeriesfetchResults = SeriesfetchResult[];
type fetchResults = fetchResult[];
type Specifications = Specification[];
export type AnnounceInserationStatus = {
  data: string
  caractersic: string
  condition: string
  equipement: string
  transmission: string
  envirement: string
  photo: string
  description: string
  price: string
  contact: string
  // isNoSmoking: boolean
  // serviceHistory: boolean
}
interface createAnnounceState {
  models: fetchResults;
  makes: fetchResults;
  trims: fetchResults;
  equipments: SeriesfetchResults;
  SeriesByYear: InputProps[];
  options: SeriesfetchResults;
  aiOptions: SeriesfetchResults;
  versionOptions: SeriesfetchResults;
  fuelType: any;
  userInputs: UserInput;
  specification: Specifications;
  selectedOptions: string[];
  selectedVersionOptions: string[];
  selectedAiOptions: number[];
  editableId: number | undefined;
  editabledAnnounce: announceById;
  pending: dataPendeing;
  inserationStatus: AnnounceInserationStatus;
  selectedCar: UserInput;
  firstError: string[];
  isChanged: boolean;
}

const state = (): createAnnounceState => ({
  models: [],
  makes: [],
  SeriesByYear: [],
  fuelType: [],
  trims: [],
  equipments: [],
  userInputs: {} as UserInput,
  options: [],
  aiOptions: [],
  versionOptions: [],
  specification: [],
  selectedOptions: [],
  selectedVersionOptions: [],
  selectedAiOptions: [],
  editableId: undefined,
  editabledAnnounce: {} as announceById,
  inserationStatus: {} as AnnounceInserationStatus,
  pending: {
    model: false,
    make: false,
    carSerie: false,
    fuelType: false,
    trim: false,
    version: false,
    bodyType: false,
    SeriesByYear: false,
    option: false,
    editbleAnnoncement: false
  },
  selectedCar: {
    make: { id: undefined, name: "" },
    model: { id: undefined, name: "" },
    trim: { id: undefined, name: "" },
    carSerie: { id: undefined, name: "" },
    bodyType: { id: undefined, name: "" },
    version: { id: undefined, name: "" },
    fuelType: { value: "" },
    year: undefined,
    versionValid: false, // Set default versionValid to false
    serieName: ''
  },
  firstError: [],
  isChanged: false,
});

const getters = {
  getMakes: (state: createAnnounceState) => {
    return state.makes;
  },
  getModels: (state: createAnnounceState) => {
    return state.models;
  },
  getEquipement: (state: createAnnounceState) => {
    return state.equipments;
  },
  getSeriesByYear: (state: createAnnounceState) => {
    return state.SeriesByYear;
  },
  getAnnounceSelectedOptions: (state: createAnnounceState) => {
    return state.selectedOptions;
  },
  getAnnounceSelectedVersionOptions: (state: createAnnounceState) => {
    return state.selectedVersionOptions;
  },
  getUserInput: (state: createAnnounceState) => {
    return state.userInputs;
  },
  getUserInputState: (state: createAnnounceState) => {
    return Object.keys(state.userInputs || {}).length !== 0;
  },
  getbodyType: (state: createAnnounceState) => {
    return (id: number) =>
      state.SeriesByYear.find((SeriesByYear) => SeriesByYear.id === id);
  },
  getFuelType: (state: createAnnounceState) => {
    return state.fuelType
  },
  getSpecificationByTrimId: (state: createAnnounceState) => {
    return (id: number) =>
      state.specification.find((specif) => specif.id === id);
  },
  getCheckedEquipementId: (_state: createAnnounceState) => {
    return (option: SeriesfetchResults) =>
      option.map((item) =>
        item.items
          ?.filter((subItem) => subItem.checked === true)
          .map((subItem) => subItem.id)
      )
        .flat();
  },
  getCheckedEquipementLabels: (state: createAnnounceState) => {
    return () =>
      state.options
        .map((item) =>
          item.items
            ?.filter((subItem) => subItem.checked === true)
            .map((subItem) => subItem.label)
        )
        .flat();
  },
  getOptions: (state: createAnnounceState) => {
    return state.options
  },
  getOptionsAi: (state: createAnnounceState) => {
    return state.aiOptions
  },
  getVersionOptions: (state: createAnnounceState) => {
    return state.versionOptions
  },
  getAnnounceSelectedAiOptions: (state: createAnnounceState) => {
    return state.selectedAiOptions;
  },
  getEditableId: (state: createAnnounceState) => {
    return state.editableId;
  },
  getEditableAnnounce: (state: createAnnounceState) => {
    return state.editabledAnnounce;
  },
  getPending: (state: createAnnounceState) => {
    return state.pending;
  },
  getAnnounceInsertStatus: (state: createAnnounceState) => {
    return state.inserationStatus;
  },
  getSelectedCar: (state: createAnnounceState) => state.selectedCar,

};

export const useAddAnnounceStore = defineStore("add_annoucement", {
  state,
  getters,
  actions: {
    setSelectedCar(data: UserInput) {
      this.selectedCar = data;
    },

    setChanged(value: boolean) {
      this.isChanged = value;
    },
    resetEditableAnnounceValue() {
      this.editableId = undefined;
      this.editabledAnnounce = {} as announceById;
      this.pending.editbleAnnoncement = false;
    },

    async announceEdit(id: number | undefined) {
      this.editableId = id;
    },
    // fetch all marks
    async fetchMarks() {
      const runTimeConfig = useRuntimeConfig();
      try {
        const response: any = await $fetch("/makes/all", {
          method: "GET",
          headers: {
            token: runTimeConfig.public.token,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        this.makes = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
    },

    addError(index: number, section: string) {
      const { query } = useRoute();

      if (!this.firstError.includes(section)) {
        this.firstError.splice(index, 0, section);
      }
      // console.log(this.firstError);
      
      if (this.firstError.length === 1) {
        navigateTo({
          path: `/listing-form/vehicle-data${query.id ? '/edit': ''}`,
          query: query || {},
          hash: `#${this.firstError[0]}`,
        });
      }

    },

    removeError(section: string) {
      this.firstError = this.firstError.filter(item => item !== section);
    },
    // fetch all model by mark

    async fetchModels(makesIdss: number[]) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.model = true;
      try {
        const response: any = await $fetch("/models/find-by-many-makes-ids", {
          method: "POST",
          headers: {
            token: runTimeConfig.public.token,
          },
          body: {
            makesIds: makesIdss,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });

        if (response.length > 0) {
          this.models = response;
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.model = false;
    },
    // fetch Type de carrosserie
    async fetchSeriesByYear(modelId: number, year: number) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.SeriesByYear = true;
      try {
        const response: fetchResults = await $fetch("/models/series-by-year", {
          method: "POST",
          body: {
            modelId: modelId,
            year: year,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        let list: SeriesfetchResults = [];
        for (const value of Object.values(response)) {
          list.push({
            id: value?.id,
            name: value.name,
            title: "" + value?.name + " " + value?.generation.name + "",
          });
        }

        this.SeriesByYear = list;
        // console.log(this.SeriesByYear);
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.SeriesByYear = false;
    },
    // fetch full type
    async fetchFuelType(serieId: number) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.fuelType = true;
      try {
        const response: any[] = await $fetch(
          "/models/fuel-types-by-serie/" + serieId,
          {
            method: "GET",
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.fuelType = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.fuelType = false;
    },
    async fetchTrims(serieId: number, fuelType: string) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.trim = true;
      try {
        const response: any = await $fetch(
          "/models/trims-by-fuel-type-and-serie",
          {
            method: "POST",
            body: {
              serieId: serieId,
              fuelType: fuelType,
            },
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.trims = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.trim = false;
    },
    async fetchEquipement(trimsId: number, state: any) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.version = true;
      try {
        const response: SeriesfetchResults = await $fetch(
          "/equipments/find/" + trimsId,
          {
            method: "GET",
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.equipments = response;

        let list: SeriesfetchResults = [];
        if (!response.length) {
          list.push({
            id: -1,
            name:
              "" +
              state.make.name +
              " " +
              state.model.name +
              " " +
              state.carSerie.name +
              " " +
              state.trim.name,
          });
          this.pending.version = false;

          return (this.equipments = list);
        }
        for (const value of response) {
          list.push({
            id: value?.id,
            name:
              "" +
              state.make.name +
              " " +
              state.model.name +
              " " +
              state.carSerie.name +
              " " +
              state.trim.name +
              " " +
              value?.name +
              "",
          });
        }
        this.pending.version = false;

        return (this.equipments = list);
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
    },
    async fetchOptions(equipementId: number) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.option = true;
      try {
        const response: SeriesfetchResults = await $fetch(
          "/options/find/all-options-ui/" + equipementId,
          {
            method: "GET",
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.options = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.option = false;
    },
    async fetchAiOptions(equipementId: number) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.option = true;
      try {
        const response: SeriesfetchResults = await $fetch(
          "/options/find/all-options-ai/" + equipementId,
          {
            method: "GET",
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.aiOptions = response;
        return response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      } finally {
        this.pending.option = false;
      }
    },
    async fetchVersionOptions(equipementId: number) {
      const runTimeConfig = useRuntimeConfig();
      this.pending.option = true;
      try {
        const response: SeriesfetchResults = await $fetch(
          "/equipments/group-options/" + equipementId,
          {
            method: "GET",
            baseURL: runTimeConfig.public.baseUrl,
          }
        );
        this.versionOptions = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
      this.pending.option = false;
    },
    async fetchSpecifications(trimsId: number) {
      const runTimeConfig = useRuntimeConfig();

      try {
        const response: any = await $fetch("/specifications/find/" + trimsId, {
          method: "GET",
          baseURL: runTimeConfig.public.baseUrl,
        });

        this.specification = response;
      } catch (error) {
        // console.log(error);
        throw new Error(String(error));
      }
    },
    async storeUserInputs(state: UserInput) {
      this.userInputs = state;
      if (state.trim?.id) {
        this.fetchSpecifications(state.trim.id);
      }
    },
    //     async dataGather(...keysValues: [string, any][] | [string, any]) {
    //       try {
    //         if (Array.isArray(keysValues[0])) {
    //           keysValues.forEach(([key, value]) => {
    //             this.announceCreation[key] = value;
    //           });
    //         } else {
    //           const [key, value] = keysValues;
    //           this.announceCreation[key] = value;
    //         }
    //       } catch (error) {
    //         console.log(error);
    // throw new Error(String(error))
    //       }
    //     },
    async gatherOptionValues(options: string[]) {
      try {
        this.selectedOptions = options;
      } catch (e) {
        // console.log(e);
      }
    },
    async gatherVersionOptionValues(options: string[]) {
      try {
        // console.log(options)  
        this.selectedVersionOptions = options;
      } catch (e) {
        // console.log(e);
      }
    },
    async gatherAiOptionValues(options: number[]) {
      try {
        const normalized = (Array.isArray(options) ? options : [])
          .map((value) => Number(value))
          .filter((value) => Number.isInteger(value));
        this.selectedAiOptions = [...new Set(normalized)];
      } catch (e) {
        // console.log(e);
      }
    },
    async fetchEditableById(announceById: string) {
      const cookieUserId = useCookie("userId");

      const runTimeConfig = useRuntimeConfig();
      this.pending.editbleAnnoncement = true;
      this.pending.SeriesByYear = true;
      try {
        const data = await $fetch<announceById>(`/announcements/find/${announceById}/${cookieUserId.value}`, {
          method: "GET",
          headers: {
            token: runTimeConfig.public.token,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        const response = await $fetch<fetchResults>("/models/series-by-year", {
          method: "POST",
          body: {
            modelId: data.model.id,
            year: data.registrationYear,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        let list: SeriesfetchResults = [];
        for (const value of Object.values(response)) {
          list.push({
            id: value?.id,
            name: value.name,
            title: `${value?.name} ${value?.generation?.name ?? ""}`.trim(),
          });
        }
        this.editabledAnnounce = data;
        this.SeriesByYear = list;
      } catch (error) {
        this.editabledAnnounce = {} as announceById;
        this.SeriesByYear = [];
        throw error;
      } finally {
        this.pending.editbleAnnoncement = false;
        this.pending.SeriesByYear = false;
      }
    },
    async creatAdd(formdata: FormData) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      const cookieUserId = useCookie("userId");
      const { fbp, fbc } = useMetaTrackingIds();
      let fetchTrace;
      const isDraft = formdata.get('isDraft') === 'true';
      formdata.set("fbp", fbp ?? "null");
      formdata.set("fbc", fbc ?? "null");
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'creatAdd');
        fetchTrace.start();
      }
      try {
        const response: any = await $fetch("/announcements/new", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: formdata,

          baseURL: runTimeConfig.public.baseUrl,
        });

        // Track successful announcement creation
        trackAnnouncementCreated({
          announcementId: response?.id,
          isDraft: isDraft,
          userId: cookieUserId.value || undefined,
          creditsUsed: isDraft ? 0 : Number(runTimeConfig.public.newAnnouncementCredits),
          totalAnnouncements: 1
        });

        return response;
        
      } catch (error: any) {
        // console.log(error);
        
        // Track announcement creation failure
        trackAnnouncementFailed({
          step: 'créer annonce',
          errorType: error?.statusCode || 'erreur inconnue',
          errorMessage: error?.message || String(error),
          isDraft: isDraft,
          userId: cookieUserId.value || undefined,
        });
        
        throw new Error(String(error));
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async editAdd(formdata: FormData) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      const cookieUserId = useCookie("userId");
      let fetchTrace;
      const isDraft = formdata.get('isDraft') === 'true';
      const isPublishing = formdata.get('public') === 'true';
      const announcementId = formdata.get('announcementId');
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'editAdd');
        fetchTrace.start();
      }

      try {
        await $fetch("/announcements/edit", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body: formdata,

          baseURL: runTimeConfig.public.baseUrl,
        });

        // Track announcement update or publish
        if (isPublishing) {
          trackAnnouncementPublished({
            announcementId: announcementId as string,
            userId: cookieUserId.value || undefined,
            creditsUsed: Number(runTimeConfig.public.newAnnouncementCredits),
          });
        } else {
          trackAnnouncementUpdated({
            announcementId: announcementId as string,
            isDraft: isDraft,
            userId: cookieUserId.value || undefined,
          });
        }

      } catch (error: any) {
        // console.log(error);
        
        // Track announcement edit failure
        trackAnnouncementFailed({
          step: isPublishing ? 'publier annonce' : 'modifier annonce',
          errorType: error?.statusCode || 'erreur inconnue',
          errorMessage: error?.message || String(error),
          isDraft: isDraft,
          userId: cookieUserId.value || undefined,
        });
        
        throw new Error(String(error));
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    AnnounceInseration(key: keyof AnnounceInserationStatus, value: string[] | string) {

      if (Array.isArray(value)) {
        this.inserationStatus[key] = value.filter(x => x != '' && x != 'undefined' && x != undefined).join(',')
      } else {
        this.inserationStatus[key] = value
      }



    }

  },
  persist: createPersistedState({
    key: 'topauto:add-announce',
    version: 1,
    scope: 'user',
    paths: [
      'userInputs',
      'selectedCar',
      'selectedOptions',
      'selectedVersionOptions',
      'editableId',
      'editabledAnnounce',
      'inserationStatus',
      'firstError',
      'isChanged'
    ]
  })
});
